import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  formControl: {
    '&.MuiFormControl-root': {
      width: '100%',
    },
  },
  radioGroup: {
    '&.MuiFormGroup-root': {
      flexDirection: 'row',
      justifyContent: 'center',
    },
  },

  modalText: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  primaryText: {
    fontStyle: 'italic',
    fontWeight: '300',
    color: theme.palette.tertiary.main,
  },

  secondaryText: {
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '21.09px',
    color: theme.palette.primary.main,
  },

  biggerModalText: {
    lineHeight: '28px',
    fontSize: '24px',
  },

  lesserModalText: {
    lineHeight: '20px',
    fontSize: '18px',
  },

  preferenceCheckbox: {
    justifyContent: 'center',
  },

  radio: {
    alignItems: 'center',
    color: theme.palette.tertiary.main,
    display: 'flex',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));
